import React from 'react'
import { Dialog, DialogContent, IconButton } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import { useStyles } from './styles'
import { concatStyles } from 'src/utils'

interface PopupProps {
  title?: string
  className?: string
  children?: React.ReactNode
  onClose?: () => void
  isOpen?: boolean
  headerBadge?: React.ReactNode | (() => React.ReactNode)
  closeOnClickOutside?: boolean
  maxWidth?: number | 'xs' | 'sm' | 'md' | 'lg' | 'xl'
  footer?: React.ReactNode | (() => React.ReactNode)
}

export const Popup: React.FC<PopupProps> = ({
  title,
  className,
  children,
  onClose,
  headerBadge,
  isOpen = true,
  closeOnClickOutside = true,
  maxWidth = 'sm',
  footer
}) => {
  const classes = useStyles()

  const handleClose = (event: any, reason: string) => {
    if (!closeOnClickOutside && reason === 'backdropClick') return
    onClose?.()
  }

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      fullWidth
      keepMounted={false}
      maxWidth={typeof maxWidth === 'string' ? maxWidth : 'lg'}
      classes={{
        paper: concatStyles(classes.dialogPaper, className)
      }}
      PaperProps={{
        style: typeof maxWidth === 'number' ? { maxWidth } : undefined
      }}
      BackdropProps={{
        style: { backgroundColor: 'rgba(0,0,0,0.4)' }
      }}
    >
      {/* HEADER */}
      {(title || onClose) && (
        <div className={classes.header}>
          <h1 className={classes.title}>
            {title}
            {headerBadge && (
              <span className={classes.headerBadge}>
                {typeof headerBadge === 'function' ? headerBadge() : headerBadge}
              </span>
            )}
          </h1>

          {onClose && (
            <IconButton onClick={onClose}>
              <CloseIcon className={classes.closeIcon} />
            </IconButton>
          )}
        </div>
      )}

      {/* CONTENT */}
      <DialogContent className={classes.content}>{children}</DialogContent>

      {/* FOOTER */}
      {footer && <div className={classes.footerPopup}>{typeof footer === 'function' ? footer() : footer}</div>}
    </Dialog>
  )
}
